import React, { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import ConnectorCreatorDialog from './ConnectorCreatorDialog';

const ConnectorCreatorContext = createContext({
  openConnectorCreator: () => {},
  closeConnectorCreator: () => {},
});

export const useConnectorCreator = () => useContext(ConnectorCreatorContext);

const ConnectorCreatorProvider = ({ children }) => {
  const [dialogConfig, setDialogConfig] = useState(null);
  const dialogConfigRef = useRef(null);

  const openConnectorCreator = useCallback((config = {}) => {
    setDialogConfig({
      defaultCreatorType: config.defaultCreatorType || 'connector',
      lockCreatorType: Boolean(config.lockCreatorType),
      deferCloseAfterCreate: Boolean(config.deferCloseAfterCreate),
      onClose: typeof config.onClose === 'function' ? config.onClose : null,
      onPluginCreated: typeof config.onPluginCreated === 'function' ? config.onPluginCreated : null,
    });
  }, []);

  const closeConnectorCreator = useCallback((event, reason) => {
    const currentConfig = dialogConfigRef.current;
    setDialogConfig(null);
    if (typeof currentConfig?.onClose === 'function') {
      currentConfig.onClose(event, reason);
    }
  }, []);

  const handlePluginCreated = useCallback((payload) => {
    const currentConfig = dialogConfigRef.current;
    if (typeof currentConfig?.onPluginCreated === 'function') {
      currentConfig.onPluginCreated(payload);
    }
  }, []);

  const contextValue = useMemo(() => ({
    openConnectorCreator,
    closeConnectorCreator,
  }), [closeConnectorCreator, openConnectorCreator]);

  useEffect(() => {
    dialogConfigRef.current = dialogConfig;
  }, [dialogConfig]);

  return (
    <ConnectorCreatorContext.Provider value={contextValue}>
      {children}
      <ConnectorCreatorDialog
        open={Boolean(dialogConfig)}
        onClose={closeConnectorCreator}
        onPluginCreated={handlePluginCreated}
        defaultCreatorType={dialogConfig?.defaultCreatorType || 'connector'}
        lockCreatorType={Boolean(dialogConfig?.lockCreatorType)}
        deferCloseAfterCreate={Boolean(dialogConfig?.deferCloseAfterCreate)}
      />
    </ConnectorCreatorContext.Provider>
  );
};

export default ConnectorCreatorProvider;
